function containEventPropagation(handler) {
    return (event) => {
        handler?.(event);
        // Portalled content must not trigger logical React ancestors such as parent actions.
        event.stopPropagation();
    };
}
/** Finalizes portaled overlay content props while containing React event propagation. */
export function getOverlayContentProps(props, { containScrollEvents = false } = {}) {
    return {
        ...props,
        onClick: containEventPropagation(props.onClick),
        onMouseDown: containEventPropagation(props.onMouseDown),
        ...(containScrollEvents && {
            // React handles events from these body-portalled overlays at document.body. Its synthetic
            // stopPropagation() also stops the native event there, before document-level listeners such
            // as Radix Dialog's RemoveScroll can cancel it. The browser's native scrolling still proceeds
            // because this does not preventDefault().
            // Remove this after upgrading to a Radix release that adds nested portalled layers to the
            // dialog's allowed scroll-lock nodes:
            // https://github.com/radix-ui/primitives/issues/3423
            onTouchMove: containEventPropagation(props.onTouchMove),
            onWheel: containEventPropagation(props.onWheel),
        }),
    };
}
//# sourceMappingURL=getOverlayContentProps.js.map